export default {
    en: {
        ARTIFACTS_ADD: 'Add an Artifact',
        ARTIFACTS_ADD_DIALOG_TITLE: 'Add an Artifact',
        ARTIFACTS_EDIT_DIALOG_TITLE: 'Edit an Artifact',
        ARTIFACTS_ADD_EDIT_DIALOG_NAME: 'Name',
        ARTIFACTS_ADD_EDIT_DIALOG_IMAGE_ALT_TEXT: 'Alternate Text',
        ARTIFACTS_ADD_EDIT_DIALOG_LINK_VALUE: 'URL',
        ARTIFACTS_ADD_EDIT_DIALOG_BOT_VALUE: 'System Prompt',
        ARTIFACTS_ADD_EDIT_DIALOG_ENVIRONMENT_VALUE: 'Environment',
        ARTIFACTS_ADD_EDIT_DIALOG_ENVIRONMENT_CATALOG_FAMILY_SUGGESTED_PARAMETER_SUFFIX: ' (suggested)',
        ARTIFACTS_ADD_EDIT_DIALOG_TYPE: 'Type',
        ARTIFACTS_ADD_EDIT_DIALOG_DELETE: 'Delete',
        ARTIFACTS_ADD_EDIT_DIALOG_TEST: 'Test',
        ARTIFACTS_ADD_EDIT_DIALOG_TEST_DISABLED: 'Enter a name and system prompt before testing',
        ARTIFACTS_TYPE_LINK: 'Link',
        ARTIFACTS_TYPE_FILE: 'File',
        ARTIFACTS_TYPE_IMAGE: 'Image',
        ARTIFACTS_EDIT_DIALOG_FILE_EDIT: 'New Artifact File',
        ARTIFACTS_EDIT_DIALOG_FILE_ADD: 'File',
        ARTIFACTS_FILE_DOWNLOAD: 'download challenge artifact',
        ARTIFACTS_IMAGE_ARTIFACT: 'challenge image',
        ARTIFACTS_LINK_TO_CHALLENGE_ARTIFACT: 'link to challenge artifact',
        ARTIFACTS_CHALLENGE_ENVIRONMENT_OPEN: 'launch challenge environment',
        ARTIFACTS_BOT_ARTIFACT_OPEN: 'open bot artifact',
        ARTIFACTS_ARTIFACT: 'challenge artifact',
        ARTIFACTS_ENVIRONMENT_ARTIFACT_DISABLED_FOR_SOLVED_CHALLENGE: 'You have already solved this challenge.',
        ARTIFACTS_ENVIRONMENT_ARTIFACT_DISABLED_NOT_A_PLAYER: 'Only CTF players and CTF admins can launch an environment',
        ARTIFACTS_TEST_BOT_DIALOG_TITLE: 'Test Bot Artifact',
        ARTIFACTS_TEST_BOT_DIALOG_DONE: 'Done',
    }
};
